import type { BrandConfig } from '../types'
import placeholderImage from './assets/placeholder.svg'
import logoImage from './assets/logo.svg'
import testimonial1 from './assets/testimonial-1.svg'
import testimonial2 from './assets/testimonial-2.svg'
import testimonial3 from './assets/testimonial-3.svg'

const config: BrandConfig = {
  appName: 'NutriCore',
  brandName: 'NutriCore',
  description: 'Sistema de agendamento para nutricionistas',
  logo: {
    src: logoImage,
    alt: 'Logótipo da marca',
  },
  heroImage: {
    src: placeholderImage,
    alt: 'Mesa com alimentos saudáveis',
  },
  serviceImage: {
    src: placeholderImage,
    alt: 'Nutricionista atendendo cliente',
  },
  testimonials: [
    {
      name: 'Dr.ª Carolina Faria',
      role: 'Nutricionista',
      text: 'Com o NutriCore, a marcação de consultas de seguimento ficou muito mais fácil para mim e para os meus pacientes.',
      image: testimonial1,
    },
    {
      name: 'Miguel Sousa',
      role: 'Paciente',
      text: 'Posso marcar as minhas consultas de nutrição a qualquer hora, o que é ótimo para a minha agenda preenchida.',
      image: testimonial2,
    },
    {
      name: 'Clínica NutriBem',
      role: 'Direção Clínica',
      text: 'A gestão de consultas e o acompanhamento de pacientes melhorou muito desde que implementámos o NutriCore.',
      image: testimonial3,
    },
  ],
  terminology: {
    professional: 'nutricionista',
    professionals: 'nutricionistas',
    business: 'consultório',
    businesses: 'consultórios',
    service: 'consulta',
    services: 'consultas',
    client: 'paciente',
    clients: 'pacientes',
    appointment: 'consulta',
    appointments: 'consultas',
  },
  homepage: {
    hero: {
      badge: 'Nutrição & Saúde',
      title: 'Transforme vidas com NutriCore',
      description: 'Organize suas consultas nutricionais e promova hábitos saudáveis com o NutriCore.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Agendar Demonstração',
      features: ['Setup em 5 minutos', 'App mobile incluído'],
    },
    statistics: [
      { value: '160+', label: 'Nutricionistas' },
      { value: '14k+', label: 'Consultas Realizadas' },
      { value: '97%', label: 'Satisfação' },
    ],
    painPoints: [
      {
        title: 'Acompanhamento Irregular',
        description: 'Pacientes esquecem-se de marcar consultas de seguimento, prejudicando o progresso.',
        icon: 'Calendar',
        quote: {
          text: 'Com lembretes automáticos, 90% dos meus pacientes mantêm o acompanhamento regular',
          author: 'Dr.ª Sofia Pereira',
          business: 'Nutrição & Bem-estar',
        },
      },
      {
        title: 'Planos Alimentares Desatualizados',
        description: 'Sem controlo regular, pacientes continuam com dietas inadequadas ao progresso.',
        icon: 'FileText',
        stats: [
          { label: 'Pacientes sem seguimento adequado:', value: '45%' },
          { label: 'Redução na eficácia do tratamento:', value: '60%' },
        ],
      },
      {
        title: 'Medições e Histórico',
        description: 'Controlar peso, medidas e evolução manualmente é trabalhoso e sujeito a erros.',
        icon: 'TrendingUp',
        quote: {
          text: 'O histórico automático permite ajustar planos com base em dados concretos',
          author: 'Dr. Ricardo Santos',
          business: 'NutriVida Clínica',
        },
      },
    ],
    solution: {
      badge: 'A Solução',
      title: 'NutriCore: O seu assistente nutricional',
      description: 'Tecnologia dedicada a nutricionistas que querem transformar vidas com alimentação saudável.',
      features: [
        {
          title: 'Consultas Programadas',
          description: 'Agende automaticamente consultas de seguimento baseadas no plano de cada paciente.',
        },
        {
          title: 'Histórico Nutricional',
          description: 'Mantenha registo completo de peso, medidas, exames e evolução de cada paciente.',
        },
        {
          title: 'Planos Personalizados',
          description: 'Crie e ajuste planos alimentares digitais com base no progresso de cada paciente.',
        },
      ],
    },
    testimonials: {
      title: 'O que os nutricionistas dizem',
      description: 'Nutricionistas que transformam vidas com apoio do NutriCore.',
    },
    finalCta: {
      title: 'Pronto para revolucionar sua prática nutricional?',
      description: 'Junte-se aos nutricionistas que já potencializaram seus resultados com o NutriCore.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Ver Demonstração',
    },
    contact: {
      title: 'Fale Conosco',
    },
  },
  auth: {
    register: {
      title: 'Criar uma conta',
      description: 'Preencha os dados abaixo para se registrar',
      inviteDescription: 'Crie sua conta para aceitar o convite de nutricionista',
      subscriptionDescription: 'Crie sua conta para finalizar sua assinatura',
      inviteCodeLabel: 'Você está usando um código de convite',
      subscriptionLabel: 'Você selecionou um plano de assinatura',
    },
    login: {
      title: 'Entrar na conta',
      description: 'Digite suas credenciais para acessar',
    },
  },
}

export default config
